import { Permissions } from '../types';
export function checkPermission(permissions: Permissions, requiredPermission: string): boolean {
  return Object.keys(permissions).some((permissionKey) =>
    createPermissionCheckRegex(permissionKey).test(requiredPermission),
  );
}

export function createPermissionCheckRegex(permissionKey: string): RegExp {
  return new RegExp('^' + permissionKey.replace(/\./g, '\\.').replace(/\*/g, '.*') + '$', 'gs');
}
